import en from './en.json';
import ru from './ru.json';
import es from './es.json';

export const languages = {
    en,
    ru,
    es,
};